import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import {
  isAlternativeForProduct,
  isMainProduct,
} from "@coworker/app/src/components/RoomSettings/Molecules/MediaArticles.helper";
import { getMainAndAlternativeProducts } from "@coworker/app/src/components/RoomSettings/tools";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { SalesStopData } from "@coworker/app/src/components/RoomSettings/types/article";
import { badge4AK1TranslationKeys } from "./badge4AK1TranslationKeys";

const itemTagBadges: Record<
  string,
  Pick<ItemBadge, "colour"> & { key: string }
> = {
  NEW_LOWER_PRICE: {
    key: "nlpString",
    colour: "red",
  },
  FAMILY_PRICE: {
    key: "familyOfferString",
    colour: "green",
  },
  NEW_PRODUCT: {
    key: "newsString",
    colour: "orange",
  },
};

export const getMediaItemBadges = (
  articleId: string,
  _allArticleIds: string[],
  t: (key: string) => string,
  hasOngoingTasks: boolean,
  salesStopData?: SalesStopData | null,
  media?: Media,
  shouldShowProductBadges = true,
  badges4AK1: string[] = [],
  itemTags: string[] = []
) => {
  const showTaskBadge = hasOngoingTasks;
  const itemBadges: ItemBadge[] = [];

  if (shouldShowProductBadges && media) {
    const mainAndAlternativeProduct = getMainAndAlternativeProducts(media);

    const isMainItem = isMainProduct(
      articleId,
      mainAndAlternativeProduct.mainProductId1,
      mainAndAlternativeProduct.mainProductId2
    );

    const isAlternativeItem = isAlternativeForProduct(
      articleId,
      mainAndAlternativeProduct.alternativeProductId1 ?? "",
      mainAndAlternativeProduct.alternativeProductId2 ?? ""
    );

    const numberMain = articleId === media.mainProductId1 ? 1 : 2;

    if (isMainItem) {
      itemBadges.push({
        text:
          numberMain === 1
            ? t("mainProductOneString")
            : t("mainProductTwoString"),
        colour: "blue",
      });
    }

    if (isAlternativeItem) {
      itemBadges.push({
        text: t("backupProductString").toUpperCase(),
        colour: "grey",
      });
    }
  }

  if (showTaskBadge) {
    itemBadges.push({
      text: (t("ongoingTasksString") as string).toUpperCase(),
      colour: "green",
    });
  }

  if (salesStopData) {
    itemBadges.push({
      text: t("salesStopString").toUpperCase(),
      colour: "red",
    });
  }

  if (badges4AK1.length > 0) {
    badges4AK1.forEach((badge) => {
      itemBadges.push({
        text: t(badge4AK1TranslationKeys[badge] ?? badge),
        colour: "yellow",
      });
    });
  }

  itemTags.forEach((tag) => {
    const badge = itemTagBadges[tag];

    if (badge) {
      itemBadges.push({
        text: t(badge.key),
        colour: badge.colour,
      });
    }
  });

  return itemBadges;
};
